import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Star.module.scss';

const Star = ({
  starId,
  setHover,
  hover,
  starsSelected,
  onClick = f => f,
}) => {
  const startClass = classNames({
    [styles.star]: true,
    [styles['star--selected']]: starId < hover || starsSelected >= starId
  });

  return (
    <div
      role="button"
      className={startClass}
      onClick={onClick}
      onMouseEnter={() => setHover(starId)}
      onMouseLeave={() => setHover(starsSelected)}
    />
  );
};

Star.propTypes = {
  starId: PropTypes.number.isRequired,
  hover: PropTypes.number.isRequired,
  starsSelected: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  setHover: PropTypes.func.isRequired,
};

export default Star;
